/**
 * The value one step up or down from `value`, kept within `min` and `max`. Returns undefined when
 * there is nothing to do: stepping down an empty field. Stepping up an empty field gives 1 (or `min`
 * if that is higher), never 0, because a blank Bedrooms or price is left out of the embed and a 0
 * would go in as a real filter value (MAX-4403 panel 7).
 */
export const stepNumber = (
	value: number | undefined,
	direction: 1 | -1,
	min?: number,
	max?: number,
): number | undefined => {
	const empty = value === undefined || Number.isNaN(value);
	if (empty && direction === -1) {
		return undefined;
	}
	let next = empty ? Math.max(min ?? 0, 1) : value + direction;
	if (min !== undefined) {
		next = Math.max(min, next);
	}
	if (max !== undefined) {
		next = Math.min(max, next);
	}
	return next;
};
